import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { ControllerApiPath } from '../services/constant';
import { SharedServiceService } from '../services/shared-service.service';
import { Observable, of } from 'rxjs';
import { Member } from '../models/member';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MemberDashboardService {

  private apiBaseUrl:string;

  constructor(private http: HttpClient,private sharedService: SharedServiceService) {
    this.apiBaseUrl = sharedService.baseUrl();
   }

   getMemberById(id:any){
    const headers = this.sharedService.createAuthorizationHeader();
    
    const url = this.apiBaseUrl + ControllerApiPath.members+'/GetMemberById?memberId='+id;
    return this.http.get<Member>(url,{ headers }).pipe(
      map((member: Member) => {
        return member;
      }));
   }

   getMemberScore(id:any,data:any){
    const headers = this.sharedService.createAuthorizationHeader();
    
    const url = this.apiBaseUrl + ControllerApiPath.scores+'?memberId='+id+'&date='+data;
    return this.http.get<Member>(url,{ headers }).pipe(
      map((member: Member) => {
        return member;
      }));
   }

   getLabWork(id:any){
    const headers = this.sharedService.createAuthorizationHeader();    
    const url = this.apiBaseUrl + ControllerApiPath.labs+'?memberId='+id;
    return this.http.get<Member>(url,{ headers });
   }

   getVital(id:any,date:any){
    const headers = this.sharedService.createAuthorizationHeader();    
    const url = this.apiBaseUrl + ControllerApiPath.vital+'?memberId='+id+'&date='+date;
    return this.http.get<Member>(url,{ headers });
   }

   getGlucose(memberId:any,fromDt:any,toDt:any){
    const headers = this.sharedService.createAuthorizationHeader();    
    const url = this.apiBaseUrl + ControllerApiPath.healthData+'/glucose?memberId='+memberId+'&startDate='+fromDt+'&endDate='+toDt;
    return this.http.get<Member>(url,{ headers }).pipe(
          map((response) => response),
          catchError((error) => {
            console.log("Fetching glucose readings error", error);
            return of(1);
          }
          ),
        );
   }
  getBmiReadings(id: any, startFrom: any, endTo: any) {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl+'vitals/GetBmiReadingsByMemberId?memberId=' + id + '&startDate=' + startFrom + '&endDate=' + endTo;
    return this.http.get(url, { headers });
  }

   getScoreReadings(id: any, startFrom: any, endTo: any) {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + ControllerApiPath.healthData+'/scores?memberId=' + id + '&startDate=' + startFrom + '&endDate=' + endTo;
    return this.http.get(url, { headers });
  }

   getHealthMetrics(memberId: any, startDate: any, endDate: any): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + ControllerApiPath.healthData + '/healthMetrics?memberId=' + memberId + '&startDate=' + startDate + '&endDate=' + endDate;
    return this.http.get<any>(url, { headers });
   }

   getHydrationGoalsByMemberId(memberId: any): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + ControllerApiPath.hydrationGoals + '/GetByMemberId?MemberId=' + memberId;
    return this.http.get<any>(url, { headers });
   }

   getHydrationLogsByMemberId(memberId: any, month: any, year: any): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + ControllerApiPath.hydrationLogs + '/GetByMemberId?memberId=' + memberId + '&month=' + month + '&year=' + year;
    return this.http.get<any>(url, { headers });
   }

   addHydrationGoal(payload: { memberId: any; loggedBy: any; goalGlasses: number; unit: string }): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + ControllerApiPath.hydrationGoals + '/Add';
    return this.http.post<any>(url, payload, { headers });
   }

   addHydrationLog(payload: { memberId: any; date: string }): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + ControllerApiPath.hydrationLogs + '/Add';
    return this.http.post<any>(url, payload, { headers });
   }

   deleteHydrationLog(memberId: any, date: string, logId: any): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + ControllerApiPath.hydrationLogs + '?memberId=' + memberId + '&date=' + date + '&logId=' + logId;
    return this.http.delete<any>(url, { headers });
   }

   sendGlucoseChatMessage(payload: any): Observable<any> {
    const headers = this.sharedService.createAuthorizatioChatAPInHeader();
    const url = environment.chatapi + '/cgm/copilot/chat';
    return this.http.post<any>(url, payload, { headers }).pipe(
      map((response) => response),
      catchError((error) => {
        console.log('Glucose chat error', error);
        return of(1);
      }),
    );
   }

   analyzeGlucoseInsights(payload: any): Observable<any> {
    const headers = this.sharedService.createAuthorizatioChatAPInHeader();
    const url = environment.chatapi + '/cgm/copilot/analyze';
    return this.http.post<any>(url, payload, { headers }).pipe(
      map((response) => response),
      catchError((error) => {
        console.log('Glucose insights error', error);
        return of(1);
      }),
    );
   }

  //  generateNbaMessage(payload: { member_id: any; response_message: string; start_date: string; end_date: string; archetypes: string[] }): Observable<any> {
  //   return this.postToMomo('/users/nba/generate-message', payload);
  //  }

   generateNbaMessage(payload: { member_id: any; response_message: string; start_date: string; end_date: string; archetypes: string[]; insights: string[] }): Observable<any> {
    console.log('Generate NBA message payload', payload);
    return this.postToMomo('/users/nba/generate-message', payload);
   }

   sendNbaGlycobrainMessage(payload: { member_id: any; message: string; action: string }): Observable<any> {
    return this.postToMomo('/users/nba/glycobrain/send', payload);
   }

   // Momo API errors are passed back as { isError: true, error } (not swallowed) so the
   // caller can show the actual error message to the user.
   private postToMomo(path: string, payload: any): Observable<any> {
    const headers = new HttpHeaders({
      Accept: 'application/json',
      'x-northstar-key': environment.MomoAPIKey,
    });
    // MomoAPIUrl ends with '/' in staging but not in prod - strip it so the path joins cleanly.
    const url = environment.MomoAPIUrl.replace(/\/+$/, '') + path;
    return this.http.post<any>(url, payload, { headers }).pipe(
      map((response) => response),
      catchError((error) => {
        console.log('Momo API error ' + path, error);
        return of({ isError: true, error });
      }),
    );
   }

   getLifeStyle(memberId:any,fromDt:any,toDt:any){
    const headers = this.sharedService.createAuthorizationHeader();    
    const url = this.apiBaseUrl + ControllerApiPath.healthData+'/nutrition?memberId='+memberId+'&startDate='+fromDt+'&endDate='+toDt;
    return this.http.get<Member>(url,{ headers });
    
   }
   getActivity(memberId:any,fromDt:any,toDt:any){
    const headers = this.sharedService.createAuthorizationHeader();    
    const url = this.apiBaseUrl + ControllerApiPath.healthData+'/activity?memberId='+memberId+'&startDate='+fromDt+'&endDate='+toDt;
    return this.http.get<Member>(url,{ headers });
    
   }
   getSleepData(memberId:any,fromDt:any,toDt:any){
    const headers = this.sharedService.createAuthorizationHeader();    
    const url = this.apiBaseUrl + ControllerApiPath.healthData+'/sleep?memberId='+memberId+'&startDate='+fromDt+'&endDate='+toDt;
    return this.http.get<Member>(url,{ headers });
    
  }
  getGraphSleepData(memberId: any, fromDt: any, toDt: any): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + ControllerApiPath.healthData + '/sleepdatabymemberid?memberId=' + memberId + '&startDate=' + fromDt + '&endDate=' + toDt;
    return this.http.get<Member>(url, { headers });

  }

    getGlucoseSummary(memberId: any, startDate: any, endDate: any){
    const headers = this.sharedService.createAuthorizationHeader();    
    const url = this.apiBaseUrl + ControllerApiPath.healthData+'/glucoseVariability?memberId='+memberId+'&startDate='+startDate+'&endDate='+endDate;
    return this.http.get<Member>(url,{ headers });
   }

  getGlucoseMedicinesRange(memberId: any, startFrom: any, endTo: any) {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + ControllerApiPath.healthData + '/glucose/medicines-range?memberId=' + memberId + '&startDate=' + startFrom + '&endDate=' + endTo;
    return this.http.get(url, { headers }).pipe(
      map((response) => response),
      catchError((error) => {
        console.log("Fetching glucose medicines range error", error);
        return of({ result: [] });
      }),
    );
  }

  getMemberBloodReportSummaries(memberId: string, pageNo: number, pageSize: number): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}MemberBloodReport/Summaries?memberId=${memberId}&pageNo=${pageNo}&pageSize=${pageSize}`;
    return this.http.get<any>(url, { headers });
  }

  getMemberBloodReportSmartSections(reportId: string): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = `${this.apiBaseUrl}MemberBloodReport/SmartSections?reportId=${reportId}`;
    return this.http.get<any>(url, { headers });
  }


  getMemberQuestsByMemberId(memberId: any) {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + ControllerApiPath.healthData + '/memberQuests?memberId=' + memberId;
    return this.http.get<Member>(url, { headers });
  }

  getMemberMoodCheckIn(memberId: any, month: string) {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + ControllerApiPath.healthData + '/memberMoodCheckIn?MemberId=' + memberId + '&Month=' + month;
    return this.http.get<any>(url, { headers });
  }

  getEnergyData(memberId: any, month: string) {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + ControllerApiPath.healthData + '/energyData?MemberId=' + memberId + '&Month=' + month;
    return this.http.get<any>(url, { headers });
  }

  getMindfulnessData(memberId: any) {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + ControllerApiPath.healthData + '/mindfulnessData?MemberId=' + memberId;
    return this.http.get<any>(url, { headers });
  }

  getMeditationData(memberId: any, startDate: any, endDate: any) {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + ControllerApiPath.healthData + '/meditationData?MemberId=' + memberId + '&StartDate=' + startDate + '&EndDate=' + endDate;
    return this.http.get<any>(url, { headers });
  }

  getMemberJournal(memberId: any): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + ControllerApiPath.healthData + '/memberJournal?memberId=' + memberId;
    return this.http.get<any>(url, { headers });
  }

  getMemberDeviceInfo(memberId: any): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + ControllerApiPath.members + '/GetMemberDeviceInfo?memberId=' + memberId;
    return this.http.get<any>(url, { headers });
  }

  getMemberPlanStatus(memberId: any): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + ControllerApiPath.members + '/GetMemberPlanStatus?memberId=' + memberId;
    return this.http.get<any>(url, { headers });
  }

  getReminderMonthView(memberId: any, month: number, year: number): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    const base = (this.apiBaseUrl ?? '').replace(/\/+$/, '');
    const url = `${base}/reminder/MonthView/${encodeURIComponent(memberId ?? '')}?month=${encodeURIComponent(
      String(month)
    )}&year=${encodeURIComponent(String(year))}`;
    return this.http.get<any>(url, { headers });
  }
}
